<template>
    <div class="h-100 d-flex flex-row justify-center align-center nav-list">
        <router-link to="/earn" class="d-flex flex-row justify-center align-center navigation-item pointer"
            :class="[{ 'navigation-item--active': currentPath === '/earn' }]">
            <v-icon>
                <earn-icon :color="currentPath === '/earn' ? '#f45484' : 'white'" :width="40"></earn-icon>
            </v-icon>
            <span class="ml-2">Earn</span>
        </router-link>

        <router-link to="/offers"
            class="d-flex flex-row justify-center align-center navigation-item pointer"
            :class="[{ 'navigation-item--active': currentPath === '/offers' }]">
            <v-icon>
                <offers-icon :color="currentPath === '/offers' ? '#f45484' : 'white'" :width="20"
                    :height="20"></offers-icon>
            </v-icon>
            <span class="ml-2">Offers</span>
        </router-link>

        <router-link to="/rewards"
            class="d-flex flex-row justify-center align-center navigation-item pointer"
            :class="[{ 'navigation-item--active': currentPath === '/rewards' }]">
            <v-icon>
                <rewards-icon :color="currentPath === '/rewards' ? '#f45484' : 'white'" :width="20"
                    :height="20"></rewards-icon>
            </v-icon>
            <span class="ml-2">Rewards</span>
        </router-link>

        <router-link to="/referrals"
            class="d-flex flex-row justify-center align-center navigation-item pointer"
            :class="[{ 'navigation-item--active': currentPath === '/referrals' }]">
            <v-icon>
                <referrals-icon :color="currentPath === '/referrals' ? '#f45484' : 'white'" :width="20"
                    :height="20"></referrals-icon>
            </v-icon>
            <span class="ml-2">Referrals</span>
        </router-link>
    </div>
</template>



<script setup>

import {computed, ref, watch} from "vue";
import { useRoute } from "vue-router";
import EarnIcon from "@/icons/Earn.vue";
import RewardsIcon from "@/icons/Rewards.vue";
import ReferralsIcon from "@/icons/Referrals.vue";
import OffersIcon from "@/icons/Offers.vue";

const route = useRoute();

const currentPath = computed(() => {
    return route.path;
});

</script>



<style scoped lang="scss">
.navigation-item {
    text-decoration: none;
    color: white;
    height: 100%;
    padding: 0 32px;

    @media (max-width: 1120px) {
        padding: 0 16px;
    }

    span {
        font-size: 16px;
        font-weight: 500;
        color: inherit;
    }

    &--active {
        overflow: visible;
        background: radial-gradient(circle at center 100%, rgba(#F83587, 10%) 0%, rgba(#F83587, 10%) 45%, transparent 60%);
        border-bottom: 4px solid transparent;
        border-image: radial-gradient(circle at bottom center, rgba(#F83587, 1) 0%, transparent 70%) 1;

        span {
            color: #F83587 !important;
        }
    }
}
</style>